import { Component } from '@angular/core';

@Component({
    selector: 'app-propulsion',
    templateUrl: './propulsion.component.html',
    styleUrl: './propulsion.component.scss',
    standalone: false
})
export class PropulsionComponent {

}
